export default "assets/images/paypal-0008c138.png";